import { render, staticRenderFns } from "./Beer.vue?vue&type=template&id=6f291b22&scoped=true&lang=html&"
import script from "./Beer.vue?vue&type=script&lang=js&"
export * from "./Beer.vue?vue&type=script&lang=js&"
import style0 from "./Beer.vue?vue&type=style&index=0&id=6f291b22&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f291b22",
  null
  
)

export default component.exports